<div *ngIf="prikaziStranicu" class="container-fluid">
    <h2 class="content-block">STANJE SKLADIŠTA</h2>
    <div class="content-block dnevniPlanWrapper">
      <div class="selectDates">
        <div class="dx-field">
          <div class="dx-fieldd">
            <dx-check-box
              [value]="sirovine"
              text="Sirovine"
              (onValueChanged)="odabranaGrupa1($event)"
              >
            </dx-check-box>
          </div>
          <div class="dx-fieldd">
            <dx-check-box
              [value]="ambalaza"
              text="Ambalaža"
              (onValueChanged)="odabranaGrupa2($event)"
              >
            </dx-check-box>
          </div>
          <div class="dx-fieldd">
            <dx-check-box
              [value]="potrosni"
              text="Potrošni"
              (onValueChanged)="odabranaGrupa3($event)"
              >
            </dx-check-box>
          </div>
          <div class="dx-fieldd">
            <dx-check-box
              [value]="svaStanja"
              text="Prikaži sva stanja"
              (onValueChanged)="prikaziSvaStanja($event)"
              >
            </dx-check-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="odabirDatuma">
            <label>Odabir skladišta:</label>
            <dx-select-box
              #selectBoxSkladisteSirovina
              [disabled]="false"
              [items]="skladistaSirovina"
              [value]="skladistaSirovina[0].idposlovnica"
              valueExpr="idposlovnica"
              displayExpr="sifrainaziv"
              [width]="500"
              (onValueChanged)="promjenaSkladista($event)"
            >
            </dx-select-box>
          </div>
        </div>
      </div>
      <div class="customTable stanjeSkladista">
        <dx-data-grid
          id="tablicaStanjeSkladista"
          [dataSource]="sveZalihe"
          noDataText="{{ poruka }}"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          [showBorders]="false"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
          (onCellPrepared)="onCellPrepared($event)"
          (onRowClick)="onRowClick($event)"
        >
          <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
            <div class="naslov">
              <h2 class="mb-0" style="padding-right: 30px">Pregled stanja skladišta</h2>
              <p class="mt-0">Kliknite na artikl za prikaz detalja</p>
            </div>
          </div>
  
          <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
          <dxo-header-filter [visible]="true"></dxo-header-filter>
  
          <dxo-search-panel
            [visible]="true"
            [width]="210"
            placeholder="Pretraži..."
          >
          </dxo-search-panel>

          <dxo-export [enabled]="dozvoli_export" fileName="pregled_stanja_skladista"></dxo-export>
  
          <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>
  
          <dxo-pager
            [showPageSizeSelector]="true"
            [allowedPageSizes]="[20, 30, 40]"
            [showInfo]="true"
          >
          </dxo-pager>

          <dxo-selection mode="single"></dxo-selection>
  
          <dxo-editing
            mode="row"
            [allowAdding]="false"
            [allowUpdating]="false"
            [allowDeleting]="false"
          ></dxo-editing>
  
          <dxi-column
            dataField="ar_sifra"
            caption="Šifra"
            alignment="right"
            [allowEditing]="false"
            width="150"
          ></dxi-column>
  
          <dxi-column
            dataField="ar_naziv"
            caption="Naziv"
            alignment="left"
            [allowEditing]="false"
            width="fit-content"
          >
            <dxo-header-filter [width]="550"></dxo-header-filter>
          </dxi-column>
  
          <dxi-column
            dataField="po_naziv"
            caption="Skladište"
            alignment="left"
            [allowEditing]="false"
            [calculateCellValue]="calculateSkladiste"
            width="300"
          >
            <dxo-header-filter [width]="450"></dxo-header-filter>
          </dxi-column>
  
          <dxi-column
            dataField="jedinicamjere_JM_SIFRA"
            caption="Jedinica mjere"
            alignment="center"
            [allowEditing]="false"
            width="150"
          ></dxi-column>

          <dxi-column cellTemplate="aktivan" caption="Aktivan" alignment="center" [width]="90" [calculateCellValue]="calculateAktivan">
            <div *dxTemplate="let data of 'aktivan'">
              <span
                *ngIf="data.data.ar_aktivan === 1"
                class="activeProcess"
              ></span>
              <span
                *ngIf="data.data.ar_aktivan === 0"
                class="inactiveProcess"
              ></span>
            </div>
          </dxi-column>
  
          <dxi-column
            dataField="za_stanje"
            caption="Stanje"
            width="150"
            [allowEditing]="false"
            alignment="right">
            <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
          </dxi-column>

          <dxo-master-detail
            [enabled]="false"
            template="detail"
          ></dxo-master-detail>

          <div *dxTemplate="let data of 'detail'" class="trenutno">

            <div class="dx-field filter_datum">
              <div class="odabirDatuma" style="margin-right: 30px">
                <label>Datum od:</label>
                <dx-date-box
                  [(value)]="datumOd"
                  [(max)]="datumDo"
                  pickerType="calendar"
                  displayFormat='dd.MM.yyyy.'
                  width="200"
                  (onValueChanged)="onValueChangedDatumOd($event)"
                >
                </dx-date-box>
              </div>
              <div class="odabirDatuma" style="margin-right: 30px">
                <label>Datum do:</label>
                <dx-date-box
                  [(value)]="datumDo"
                  [(min)]="datumOd"
                  pickerType="calendar"
                  displayFormat='dd.MM.yyyy.'
                  width="200"
                  (onValueChanged)="onValueChangedDatumDo($event)"
                >
                </dx-date-box>
              </div>
              <div class="odabirDatuma">
                <dx-button
                  class="btn_trazi"
                  [disabled]="disableGumb"
                  stylingMode="contained"
                  text="Prikaži"
                  type="success"
                  [width]="120"
                  (onClick)="pretrazi(datumOd, datumDo)">
                </dx-button>
              </div>
            </div>

            <dx-data-grid
              [dataSource]="stavke"
              [showColumnLines]="true"
              [wordWrapEnabled]="true"
              keyExpr="pz_id"
              noDataText="{{ poruka }}"
              [showBorders]="false">

              <dxo-filter-row [visible]="true"></dxo-filter-row>
              <dxo-header-filter [visible]="true"></dxo-header-filter>
            
              <dxi-column
                dataField="ar_lot"
                caption="LOT"
                [width]="120"
                alignment="right"
              ></dxi-column>
              <dxi-column
                dataField="pz_datum"
                dataType="date"
                caption="Datum"
                [width]="150"
                alignment="center"
              ></dxi-column>
              <dxi-column
                cellTemplate="linkTemplate"
                caption="Dok. broj"
                [width]="140"
                alignment="center">
                  <div *dxTemplate="let data of 'linkTemplate'">
                    <a (click)="ispisiPDF(data)">{{data.data.pz_broj}}</a>
                  </div>
              </dxi-column>
              <dxi-column
                dataField="dv_naziv"
                caption="Vrsta dok."
                [width]="300"
                alignment="center"
              ></dxi-column>
              <dxi-column
                dataField="ps_ulaz"
                caption="Ulaz"
                [width]="120"
                alignment="right"
                [allowFiltering]="false"
              >
                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
              </dxi-column>
              <dxi-column
                dataField="ps_izlaz"
                caption="Izlaz"
                [width]="120"
                alignment="right"
                [allowFiltering]="false"
              >
                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
              </dxi-column>
              <dxi-column
                dataField="ps_stanje"
                caption="Stanje"
                [width]="120"
                alignment="right"
                [allowFiltering]="false"
              >
                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
              </dxi-column>
              <dxi-column
                dataField="ps_ulazc"
                caption="Ulazna cijena"
                [width]="120"
                alignment="right"
                [allowFiltering]="false"
              >
                <dxo-format type="fixedPoint" [precision]="3"></dxo-format>
              </dxi-column>
              <dxi-column
                dataField="ps_izlazc"
                caption="Izlazna cijena"
                [width]="120"
                alignment="right"
                [allowFiltering]="false"
              >
                <dxo-format type="fixedPoint" [precision]="3"></dxo-format>
              </dxi-column>

              <dxo-summary>
                <dxi-total-item 
                  column="dv_naziv" 
                  summaryType="sum" 
                  alignment="left" 
                  displayFormat="Ukupno:">
                </dxi-total-item>
                <dxi-total-item
                  column="ps_ulaz"
                  summaryType="sum"
                  alignment="right"
                  displayFormat="{0}"
                  [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
                </dxi-total-item>
                <dxi-total-item
                  column="ps_izlaz"
                  summaryType="sum"
                  alignment="right"
                  displayFormat="{0}"
                  [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
                </dxi-total-item>
                <dxi-total-item
                  column="ps_stanje"
                  summaryType="sum"
                  alignment="right"
                  displayFormat="{0}"
                  [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
                </dxi-total-item>
              </dxo-summary>

            </dx-data-grid>
          </div>
          
        </dx-data-grid>
      </div>
    </div>
</div>
    